import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Bottleneck from "bottleneck";

import { generateiHrAuthHeaders } from './utils'

import { getPodcastFollows, searchPodcastShows, putFollowPodcastById, } from '../../app/services/ihr-amp'

// Google Recaptcha Client Key
const GRECAPTCHAKEY = process.env.REACT_APP_GRECAPTCHAKEY;

// rate limiter/throttling
const limiter = new Bottleneck({
  maxConcurrent: 1,
  minTime: 100
});
// uncomment below to enable throttle logging
/* limiter.on("debug", function (message, data) {
  // Useful to figure out what the limiter is doing in real time
  // and to help debug your application
  console.debug('limiter - on - debug', JSON.parse(JSON.stringify({message, data})));
}); */

const initialState = {
  value: 0,
  view: 'landing',
  status: 'file-upload',
  recaptcha: {
    sitekey: GRECAPTCHAKEY,
    valid: false,
    value: null,
    error: null,
  },
  fileUpload: {
    loading: false,
    fileName: null,
    fileData: null,
    valid: false,
    json: null,
    formError: false,
    error: null,
  },
  podcastSearch: {
    loading: false,
    following: null,
    found: null,
    notFound: null,
    error: null,
    progress: 0,
  },
  podcastFollows: {
    loading: false,
    selectedFollows: null,
    totalFollows: 0,
    followsAdded: null,
    followsErrors: null,
    error: null,
    progress: 0,
  },
}

const recaptchaService = async (recaptchaToken) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({
      grecaptchaClient: 'ihrpodcastimport',
      recaptchaToken,
    })
  };
  try {
    const res = await fetch('https://ihm-qw-public-api-proxy.azurewebsites.net/api/podcast-nominate/recaptcha/?code=zzjqVm0URyap8gwAv4Dq8QXsCHu9xo7H1jyZahzTnN8WAzFuKNrZEQ==', requestOptions)
    const resJSON = await res.json();
    if (res.ok) {
      return resJSON;
    }
    throw resJSON
  } catch (error) {
    let errorBody
    if (error.type) {
      errorBody = error
    } else {
      errorBody = {
        type: 'recaptcha',
        message: 'Recaptcha Failed',
        rawError: error && error.message ? error.message : error,
      }
    }
    throw errorBody
  }
}

export const postPodcastSearch = createAsyncThunk(
  'podcastSubmit/postPodcastSearch',
  async (args, { getState, rejectWithValue, dispatch}) => {
    //console.debug('podcastSearch - args', args);
    const { 
      recaptchaToken, 
      lookup, 
    } = args;
    const headers = await generateiHrAuthHeaders(getState, 'postPodcastSearch');
    //console.debug('podcastSearch - headers', headers);
    //const state = getState();
    //const { podcastSearch } = state.podcastSubmit;
    //console.debug('podcastSearch - state.podcastSubmit.podcastSearch', podcastSearch);

    let payloadResponse = {
      following: null,
      found: [],
      selectedFollows: {},
      recaptchaResponse: null
    }

    let progress = 0;

    try {
      // exchange recaptcha token
      try {
        const recaptchaResponse = await recaptchaService(recaptchaToken);
        //console.debug('podcastSearch - recaptchaResponse', recaptchaResponse);
        payloadResponse.recaptchaResponse = recaptchaResponse;
      } catch (error) {
        //console.debug('podcastSearch - recaptchaResponse - error', error);
        const errorBody = {
          type: 'podcast-search',
          message: 'Recaptcha Failed',
          rawError: error && error.message ? error.message : error,
        }
        payloadResponse.recaptchaResponse = errorBody;
      }      
      // get logged in users Podcast Following to see what shows they already have added
      const userPodcastFollows = await limiter.schedule({id: 'getPodcastFollows'},() => getPodcastFollows(headers))
      //console.debug('podcastSearch - userPodcastFollows', userPodcastFollows);
      if (userPodcastFollows.data) {
        payloadResponse.following = userPodcastFollows.data
      }
      // search for Podcast Shows by name instead of RSS Feed URL
      if (lookup.length !== 0) {
        for (let podcastToImport of JSON.parse(JSON.stringify(lookup))) {
          //console.debug('podcastSearch - podcastToImport', podcastToImport);
          // test for podcastToImport.title and if not available search for anything
          const searchInput = podcastToImport.title ? podcastToImport.title : '';
          //console.debug('podcastSearch - podcastToImport - searchInput', searchInput);
          try {
            const podcastLookupResponse = await limiter.schedule({id: searchInput},() => searchPodcastShows(headers, searchInput));
            //console.debug('podcastSearch - podcastLookupResponse', podcastLookupResponse);
            podcastToImport.searchResults = podcastLookupResponse;
            // update Podcast already followed by user
            const foundFollowing = payloadResponse.following && payloadResponse.following.filter(podcast => podcast.id === podcastLookupResponse.bestMatch.id);
            podcastToImport.following = foundFollowing && foundFollowing.length !==0 && foundFollowing[0] ? true : false;
            payloadResponse.found = [...payloadResponse.found, podcastToImport]
            const ihrPodcastId = podcastLookupResponse.bestMatch.id
            // test if user already following podcast
            // const selectedFollow = !podcastToImport.following ? ihrPodcastId : 'removed';
            // payloadResponse.selectedFollows = [...payloadResponse.selectedFollows, selectedFollow];
            if (!podcastToImport.following) {
              payloadResponse.selectedFollows[ihrPodcastId] = {id: ihrPodcastId};
            }
          } catch (error) {
            podcastToImport.error = error;
            payloadResponse.found = [...payloadResponse.found, podcastToImport];
            //payloadResponse.selectedFollows = [...payloadResponse.selectedFollows, 'removed'];
          }
          // update progress
          progress++
          dispatch(podcastSubmitSlice.actions.setProgress(progress))
        }
      }
      //console.debug('podcastSearch - payloadResponse.found ', payloadResponse.found);
      
      return payloadResponse
    } catch (error) {
      //console.debug('podcastSearch - error', error);
      let errorBody
      if (error.type) {
        errorBody = error
      } else {
        errorBody = {
          type: 'podcast-search',
          message: 'Podcast Search Failed',
          rawError: error && error.message ? error.message : error,
        }
      }
      return rejectWithValue(errorBody)
    }
})

export const addPodcastFollows = createAsyncThunk(
  'podcastSubmit/addPodcastFollows',
  async (args, { getState, rejectWithValue, dispatch }) => {
    //console.debug('addPodcastFollows - args', args);
    //const { selectedFollows, } = args;
    const headers = await generateiHrAuthHeaders(getState, 'addPodcastFollows');
    //console.debug('addPodcastFollows - headers', headers);
    const state = getState();
    const { podcastFollows, podcastSearch } = state.podcastSubmit;
    //console.debug('addPodcastFollows - state.podcastSubmit.podcastFollows', podcastFollows);
    const { selectedFollows, } = podcastFollows;

    let payloadResponse = {
      followsAdded: [],
      followsErrors: [],
    }

    let progress = 0;

    try {
      // for each selected podcast follow, add/put podcast follow
      let userSelectedPodcastFollows = [];
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(selectedFollows)) {
        //console.debug('addPodcastFollows - item', {key, value});
        userSelectedPodcastFollows = [...userSelectedPodcastFollows, value.id]
      }

      //const userSelectedPodcastFollows = selectedFollows && selectedFollows.length !== 0 && selectedFollows.filter(followId => followId !== 'removed');
      //console.debug('addPodcastFollows - userSelectedPodcastFollows', userSelectedPodcastFollows);
      // test for follows to add
      if (userSelectedPodcastFollows.length !== 0) {
        for (let podcastToFollowId of JSON.parse(JSON.stringify(userSelectedPodcastFollows))) {
          //console.debug('addPodcastFollows - podcastToFollowId', podcastToFollowId);
          try {
            let addPodcastFollowResponse = await limiter.schedule({id: podcastToFollowId},() => putFollowPodcastById(headers, podcastToFollowId));
            //console.debug('addPodcastFollows - addPodcastFollowResponse', addPodcastFollowResponse);
            //look for podcast image
            const foundPodcast = podcastSearch.found && podcastSearch.found.filter(podcast => podcast.searchResults.bestMatch.id === podcastToFollowId);
            //console.debug('addPodcastFollows - foundPodcast', foundPodcast);
            const foundPocastImage = foundPodcast && foundPodcast.length !== 0 && foundPodcast[0]?.searchResults?.bestMatch?.podcast?.image ? foundPodcast[0].searchResults.bestMatch.podcast.image : null;
            //console.debug('addPodcastFollows - foundPocastImage', foundPocastImage);
            addPodcastFollowResponse.image = foundPocastImage;
            payloadResponse.followsAdded = [...payloadResponse.followsAdded , addPodcastFollowResponse];
          } catch (error) {
            const errorResponse = {
              id: podcastToFollowId,
              error
            }
            //payloadResponse.followsAdded = [...payloadResponse.followsAdded, errorResponse]
            payloadResponse.followsErrors = [...payloadResponse.followsErrors, errorResponse]
          }
          // update progress
          progress++
          dispatch(podcastSubmitSlice.actions.setProgressFollow(progress))
        }
      }
      //console.debug('addPodcastFollows - payloadResponse ', payloadResponse);
      if (payloadResponse.followsAdded.length === 0 && payloadResponse.followsErrors.length !== 0) {
        throw payloadResponse
      }
      return payloadResponse
    } catch (error) {
      //console.debug('addPodcastFollows - error', error);
      let errorBody
      if (error.type) {
        errorBody = error
      } else {
        errorBody = {
          type: 'add-podcast-follows',
          message: 'Add Podcast Follows Failed',
          rawError: error && error.message ? error.message : error,
        }
      }
      return rejectWithValue(errorBody)
    }
})

export const podcastSubmitSlice = createSlice({
  name: 'podcastSubmit',
  initialState,
  reducers: {
    setProgress: (state, action) => {
      state.podcastSearch.progress = action.payload
    },
    setProgressFollow: (state, action) => {
      state.podcastFollows.progress = action.payload
    },
    setActiveView: (state, action) => {
      state.view = action.payload
    },
    setActiveStatus: (state, action) => {
      state.status = action.payload ? action.payload : initialState.status
    },
    resetActiveViewForm: (state, action) => {
      state.view = initialState.view
      state.status = initialState.status
      state.recaptcha = initialState.recaptcha
      state.rssVerification = initialState.rssVerification
      state.submitPodcast = initialState.submitPodcast
      state.fileUpload = initialState.fileUpload
      state.podcastSearch = initialState.podcastSearch
      state.podcastFollows = initialState.podcastFollows
    },
    setRecaptcha: (state, action) => {
      state.recaptcha.valid = action.payload.error ? false : true
      state.recaptcha.value = action.payload.value ? action.payload.value : null
      state.recaptcha.error = action.payload.error ? true : false
      state.fileUpload.formError = action.payload.error ? true : false
      //state.rssVerification.error = action.payload.error ? action.payload.error : null
    },
    toggleFileValidateLoading: (state, action) => {
      state.fileUpload.loading = !state.fileUpload.loading
    },
    setFileValidate: (state, action) => {
      state.fileUpload.fileName = action.payload.fileName ? action.payload.fileName : null
      state.fileUpload.fileData = action.payload.fileData ? action.payload.fileData : null
      state.fileUpload.json = action.payload.json ? action.payload.json : null
      state.fileUpload.valid = !action.payload.error ? true : false
      state.fileUpload.error = action.payload.error ? action.payload.error : false
      state.fileUpload.formError = action.payload.error ? true : false
      state.fileUpload.loading = false
    },
    resetFileValidate: (state, action) => {
      state.fileUpload = initialState.fileUpload
    },
    setPodcastFollows: (state, action) => {
      //const totalFollows = action.payload.filter(follow => follow !== 'removed');
      let updatedSelectedFollows = JSON.parse(JSON.stringify(state.podcastFollows.selectedFollows));
      if (typeof updatedSelectedFollows[action.payload] === 'undefined') {
        updatedSelectedFollows[action.payload] = {id: action.payload};
      } else {
        if (updatedSelectedFollows && updatedSelectedFollows[action.payload]) {
          delete updatedSelectedFollows[action.payload]
        }
      }
      state.podcastFollows.selectedFollows = action.payload ? updatedSelectedFollows : state.podcastFollows.selectedFollows
      state.podcastFollows.totalFollows = updatedSelectedFollows ? Object.keys(updatedSelectedFollows).length : state.podcastFollows.totalFollows
    },
    selectSimilarPodcast: (state, action) => {
      //const totalFollows = action.payload.updatedFollows.filter(follow => follow !== 'removed');
      const foundFollowing = state.podcastSearch.following && state.podcastSearch.following.filter(alreadyFollowedPodcast => alreadyFollowedPodcast.id === action.payload.bestMatch.id);
      let updatedSelectedFollows = JSON.parse(JSON.stringify(state.podcastFollows.selectedFollows));
      updatedSelectedFollows[action.payload.podcastId] = {id: action.payload.podcastId};
      const currentPodcastId = state.podcastSearch.found[action.payload.index].searchResults.bestMatch.id;
      if (currentPodcastId && updatedSelectedFollows[currentPodcastId]) {
        delete updatedSelectedFollows[currentPodcastId]
      }

      state.podcastSearch.found[action.payload.index].following = foundFollowing.length === 0 ? false : true;
      state.podcastSearch.found[action.payload.index].searchResults.bestMatch = action.payload.bestMatch ? action.payload.bestMatch : state.podcastSearch.found[action.payload.index].searchResults.bestMatch;
      state.podcastFollows.selectedFollows = action.payload.podcastId ? updatedSelectedFollows : state.podcastFollows.selectedFollows;
      //const totalFollows = action.payload.updatedFollows.filter(follow => follow !== 'removed');
      state.podcastFollows.totalFollows = updatedSelectedFollows ? Object.keys(updatedSelectedFollows).length : state.podcastFollows.totalFollows
    },
  },
  extraReducers: {
    [postPodcastSearch.pending]: (state) => {
      state.status = 'podcast-search'
      state.podcastSearch.loading = true
      state.podcastSearch.error = null
    },
    [postPodcastSearch.fulfilled]: (state, { payload }) => {
      //state.status = 'podcast-search'
      state.podcastSearch.loading = false
      state.podcastSearch.following = payload.following ? payload.following : state.podcastSearch.following
      state.podcastSearch.found = payload.found ? payload.found : state.podcastSearch.found
      state.podcastFollows.selectedFollows = payload.selectedFollows ? payload.selectedFollows : state.podcastFollows.selectedFollows
      state.podcastFollows.totalFollows = payload.selectedFollows ? Object.keys(payload.selectedFollows).length : state.podcastFollows.totalFollows
    },
    [postPodcastSearch.rejected]: (state, { payload }) => {
      state.podcastSearch.loading = false
      state.podcastSearch.error = payload
    },
    [addPodcastFollows.pending]: (state) => {
      //state.status = 'podcast-search'
      state.podcastFollows.loading = true
      state.podcastFollows.error = null
    },
    [addPodcastFollows.fulfilled]: (state, { payload }) => {
      state.view = 'podcast-follows-complete'
      state.podcastFollows.loading = false
      state.podcastFollows.followsAdded = payload.followsAdded ? payload.followsAdded : state.podcastFollows.followsAdded
      state.podcastFollows.followsErrors = payload.followsErrors ? payload.followsErrors : state.podcastFollows.followsErrors
    },
    [addPodcastFollows.rejected]: (state, { payload }) => {
      state.podcastFollows.loading = false
      state.podcastFollows.error = payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setActiveView, setActiveStatus, resetActiveViewForm, setRecaptcha, setFileValidate, toggleFileValidateLoading, resetFileValidate, setPodcastFollows, selectSimilarPodcast, setProgress, setProgressFollow, } = podcastSubmitSlice.actions;
export const selectPodcastSubmit = (state) => state.podcastSubmit;
export const podcastSubmitReducer = podcastSubmitSlice.reducer